import { render, staticRenderFns } from "./TicketingProcessGantt.vue?vue&type=template&id=2d36d524&scoped=true&lang=pug&"
import script from "./TicketingProcessGantt.vue?vue&type=script&lang=ts&"
export * from "./TicketingProcessGantt.vue?vue&type=script&lang=ts&"
import style0 from "./TicketingProcessGantt.vue?vue&type=style&index=0&id=2d36d524&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d36d524",
  null
  
)

export default component.exports